/**
 * Возвращает свойство объекта, если оно существует или null,
 * вместо ошибки в консоль если свойства на каком то из уровней вложенности нет.
 * Уровни вложенности разделяются точкой.
 * @param obj
 * @param key
 */
export const getObjectValue = <T>(obj: object, key: string): any => {
    if (obj === null || obj === undefined) {
      return null;
    }
  
    const keyArr = key.split('.');
    let o = obj;
    for (const k of keyArr) {
      if (!o.hasOwnProperty(k) || o[k] === null || o[k] === undefined) {
        return null;
      }
      o = o[k];
    }
  
    return o;
  };
  


// WEBPACK FOOTER //
// ./src/app/utils/getObjectValue.ts